package dk.smark.chat.di

import dk.smark.chat.FriendsViewModel
import dk.smark.chat.MainViewModel
import dk.smark.chat.auth.CredentialsStorage
import dk.smark.chat.auth.createCredentialsStorage
import dk.smark.chat.crypto.CryptoProvider
import dk.smark.chat.crypto.createCryptoProvider
import dk.smark.chat.network.ChatApiService
import dk.smark.chat.network.FriendApiService
import dk.smark.chat.network.UserApiService
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

val appModule = module {
    single { UserApiService() }
    single { ChatApiService() }
    single { FriendApiService() }
    single<CredentialsStorage> { createCredentialsStorage() }
    single<CryptoProvider> { createCryptoProvider() }
    viewModel { MainViewModel(get(), get()) }
    viewModel { FriendsViewModel(get(), get()) }
}